import React, { useEffect, useState } from "react";
import SessionReservationForm from "./SessionReservationForm";
import Heading from "../components/NewUi/heading/Heading";
import auth from "../services/authServices";
import http from "../services/httpServices";
import PreviousUserLiveSessions from "./PreviousUserLiveSessions";
import UpcomingLiveSessions from "./UpcomingLiveSessions";
import { printUnit } from "../utils/ar";
import LoadingIcon from "../components/ui/LoadingIcon";
import { useLanguage } from "../context/LanguageContext";

const SessionReservation = () => {
    const { language } = useLanguage();
    const [requestedSessions, setRequestedSessions] = useState({
        upcoming_live_sessions: [],
        previous_live_sessions: [],
        user_available_sessions_count: 0,
    });
    const [isLoading, setIsLoading] = useState(false);
    const getAttendantSessions = async () => {
        setIsLoading(true);
        const token = auth.getToken();
        const config = auth.getAuthConfig(token);
        try {
            const { data: response } = await http.get(
                `/api/live_sessions/requested_sessions`,
                config
            );
            setRequestedSessions(response);
            setIsLoading(false);
        } catch ({ response }) {
            // console.log(error);
        }
    };
    const content = {
        loading: {
            en: "Loading data...",
            ar: "جاري تحميل البيانات",
        },
        remainingSessions: {
            en: "Your current remaining balance of sessions you can book",
            ar: "رصيدك الحالي المتبقي من الجلسات اللي ممكن تحجزها",
        },
        noRemainingBalance: {
            en: "You don't have any remaining balance!",
            ar: "لا يوجد لديك رصيد متبقي !",
        },
        warning: {
            en: "Important Note!",
            ar: "تنبيه هام !",
        },
        warningMessage: {
            en: {
                first_text: "Be aware that you are allowed to",
                highlighted: "book only one session per week.",
                end_text:
                    "If you book a session and don't show up, it will count as an absence and you won't be able to compensate for it.",
            },
            ar: {
                first_text: "خلي بالك انت بيكون ليك حق ",
                highlighted: "تحجز جلسة واحدة فقط في الأسبوع",
                end_text: "الواحد ولو حجزت جلسة ومجيتش هتتحسب عليك كغياب ومش هتقدر تعوضها",
            },
        },
        noSessionsHeading: {
            text: {
                en: "suitable time",
                ar: "وقت يناسبك",
            },
            highlight: {
                en: "for a quick session?",
                ar: "لجلسة سريعة؟",
            },
        },
        noSessionsDescription: {
            en: "We’ve made it simpler for you. Now you can book an individual session with assistant teachers. Just pick your suitable day, and all available times will appear.",
            ar: "بسطتنهالك اكتر من كده .. دلوقتي بقي متاح ليك جلسة مع المُدرسين المُساعدين بشكل منفرد بحيث نقربلك المسافات كل الي عليك اختار اليوم المُناسب ليك وهيظهرلك كل المواعيد المتاحة للجلسة للمدرس الي حابب يبقي معاك",
        },
    };
    useEffect(() => {
        getAttendantSessions();
    }, []);
    return (
        <div
            className={`h-full min-h-screen flex-col space-y-20 flex-center-both py-20 px-4 md:px-10 ${language}`}
        >
            {/* user_available_sessions_count */}

            {isLoading ? (
                <div className="flex-center-both flex-row space-x-3 space-x-reverse bg-third-container clr-text-primary border border-secondary-container smooth py-5 px-5 rounded-md">
                    <div className="font-w-bold font-h1 text-sky-500">
                        <LoadingIcon />
                    </div>
                    <div className="font-w-bold font-h3">{content.loading[language]}</div>{" "}
                </div>
            ) : requestedSessions.upcoming_live_sessions &&
              requestedSessions.upcoming_live_sessions.length > 0 ? (
                <>
                    <UpcomingLiveSessions
                        UpcomingLiveSessions={requestedSessions.upcoming_live_sessions}
                    />
                    <div className="bg-sky-100 dark:bg-sky-900 text-sky-900 dark:text-sky-100 border-sky-500 rounded-md smooth border p-5 flex-center-both flex-col">
                        <h1>{content.remainingSessions[language]}</h1>
                        <h2 className="font-h3 font-w-bold">
                            {requestedSessions.user_available_sessions_count > 0
                                ? printUnit(
                                      requestedSessions.user_available_sessions_count,
                                      "جلسة",
                                      language
                                  )
                                : content.noRemainingBalance[language]}
                        </h2>
                    </div>
                    <PreviousUserLiveSessions
                        previousSessions={requestedSessions.previous_live_sessions}
                        getAttendantSessions={getAttendantSessions}
                    />
                </>
            ) : (
                <>
                    <div className="flex-center-both flex-col space-y-10">
                        <Heading
                            title={content.noSessionsHeading.text[language]}
                            subtitle={content.noSessionsHeading.highlight[language]}
                        />

                        <p className="text-gray-700 text-center w-full md:w-1/2 dark:text-gray-200 smooth">
                            {content.noSessionsDescription[language]}
                        </p>
                        <PreviousUserLiveSessions
                            previousSessions={requestedSessions.previous_live_sessions}
                            getAttendantSessions={getAttendantSessions}
                        />
                    </div>
                    <div className="bg-sky-100 dark:bg-sky-900 text-sky-900 dark:text-sky-100 border-sky-500 rounded-md smooth border p-5 flex-center-both flex-col">
                        <h1 className="font-">{content.remainingSessions[language]}</h1>
                        <h2 className="font-h3 font-w-bold">
                            {requestedSessions.user_available_sessions_count > 0
                                ? printUnit(
                                      requestedSessions.user_available_sessions_count,
                                      "جلسة",
                                      language
                                  )
                                : content.noRemainingBalance[language]}{" "}
                        </h2>
                        <div className="py-2 text-center">
                            <div>{content.warning[language]}</div>
                            <div>
                                {content.warningMessage[language].first_text}{" "}
                                <span className="text-rose-500">
                                    {content.warningMessage[language].highlighted}{" "}
                                </span>{" "}
                                {content.warningMessage[language].end_text}{" "}
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col space-y-8">
                        <SessionReservationForm
                            afterSuccess={getAttendantSessions}
                            userAvailableSessionsCount={
                                requestedSessions.user_available_sessions_count
                            }
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default SessionReservation;
